module.exports = __webpack_public_path__ + "static/media/bg.a3c56367.png";